// ebookData.js
const ebookData = [
    { title: 'Learn Frontend Development', author: 'Chinonso Okeke', downloadLink: 'https://example.com/ebook/frontend.pdf' },
    { title: 'Backend for Beginners', author: 'Amina Yusuf', downloadLink: 'https://example.com/ebook/backend.pdf' },
    { title: 'Fullstack Handbook', author: 'Emeka Nwankwo', downloadLink: 'https://example.com/ebook/fullstack.pdf' },
    { title: 'UI/UX Design Guide', author: 'Ngozi Uche', downloadLink: 'https://example.com/ebook/uiux.pdf' },
    { title: 'Principles of Software Engineering', author: 'Tunde Balogun', downloadLink: 'https://example.com/ebook/engineering.pdf' },
    { title: 'Data Science Essentials', author: 'Zainab Mohammed', downloadLink: 'https://example.com/ebook/datascience.pdf' },
    // Add more eBooks as needed
  ];
  
  export default ebookData;
  